import Vue from 'vue';
import axios from 'axios';
import _loading from '@/components/_loading.vue'

const base = 'https://espacowinnicottbsb.com.br';
const Loading = {
		  begin(msg){
		    const ComponentClass = Vue.extend(_loading)
		    let instance = new ComponentClass({
		      propsData: { msg: msg }
		    })
		    instance.$mount() // pass nothing
		    const lc =  document.getElementById('loading-container');
		    if(lc)
		      lc.appendChild(instance.$el)
		  },
		  end(){
		    const lc = document.getElementById('loading-container');
		    if(lc)
		    {
		      if (lc.children[0])
		        lc.children[0].classList.add("hide");
		      setTimeout(()=> lc.innerHTML = '', 1000);
		    }
		  }
		}

export default {
	getBaseUrl(){
		return base;
	},
	get({msg, params, url, silent}, fun_success, fun_fail){
	  if(!silent) Loading.begin(msg);
	  axios.get(`${base}${url}`,{
        params: params
      }).then(function(success){
          fun_success(success.data)
          if(!silent) Loading.end();
      }).catch(function(error){
          fun_fail(error)
          if(!silent) Loading.end();
      })
	},
	post({msg, params, data, url, silent}, fun_success, fun_fail){
	  if(!silent) Loading.begin(msg);
	  axios.request({
		  url: `${base}${url}`,
		  method: 'post', // default
		  params: params,
		  data: {data: data},
		  responseType: 'json', // default
		  responseEncoding: 'utf8', // default
      }).then(function(success){
          fun_success(success.data)
          if(!silent) Loading.end();
      }).catch(function(error){
          fun_fail(error)
          if(!silent) Loading.end();
      })
	},
	getAuthed({msg, session, params, url, silent}, fun_success, fun_fail){
	  if(!silent) Loading.begin(msg);
	  axios.request({
		  url: `${base}${url}`,
		  method: 'get', // default
		  headers: { 'authorization': `bearer ${session.jwt}` },
		  params: params,
		  responseType: 'json', // default
		  responseEncoding: 'utf8', // default
      }).then(function(success){
          fun_success(success.data)
          if(!silent) Loading.end();
      }).catch(function(error){
          fun_fail(error)
          if(!silent)Loading.end();
      })
	},
	postAuthed({msg, session, params, data, url, silent}, fun_success, fun_fail){
	  if(!silent) Loading.begin(msg);
	  axios.request({
		  url: `${base}${url}`,
		  method: 'post', // default
		  headers: { 'authorization': `bearer ${session.jwt}` },
		  params: params,
		  data: {data: data},
		  responseType: 'json', // default
		  responseEncoding: 'utf8', // default
      }).then(function(success){
          fun_success(success.data)
          if(!silent) Loading.end();
      }).catch(function(error){
          fun_fail(error)
          if(!silent) Loading.end();
      })
	},
	putAuthed({msg, session, params, data, url, silent}, fun_success, fun_fail){
	  if(!silent) Loading.begin(msg);
	  axios.request({
		  url: `${base}${url}`,
		  method: 'put', // default
		  headers: { 'authorization': `bearer ${session.jwt}` },
		  params: params,
		  data: {data: data},
		  responseType: 'json', // default
		  responseEncoding: 'utf8', // default
      }).then(function(success){
          fun_success(success.data)
          if(!silent) Loading.end();
      }).catch(function(error){
          fun_fail(error)
          if(!silent) Loading.end();
      })
	},
	deleteAuthed({msg, session, params, data, url, silent}, fun_success, fun_fail){
	  if(!silent) Loading.begin(msg);
	  axios.request({
		  url: `${base}${url}`,
		  method: 'delete', // default
		  headers: { 'authorization': `bearer ${session.jwt}` },
		  params: params,
		  data: {data: data},
		  responseType: 'json', // default
		  responseEncoding: 'utf8', // default
      }).then(function(success){
          fun_success(success.data)
          if(!silent) Loading.end();
      }).catch(function(error){
          fun_fail(error)
          if(!silent) Loading.end();
      })
	},

}